import styled, { keyframes } from 'styled-components';

const gradientKeyframeAnimation = keyframes`
    from {
        left: 0%;
    }
    to {
        left: 100%;
    }
`;

interface AnimatedLoadingPlaceholderProp {
    width?: number;
    height?: string;
    radius?: number;
}
export const AnimatedLoadingPlaceholder = styled.div<AnimatedLoadingPlaceholderProp>`
    display: flex;
    width: ${({ width }) => width ? `${width}px` : '100%'};
    height: ${({ height }) => height ? height : '16px'};
    background: #e0e0e0;
    border-radius: ${({ radius }) => radius ? `${radius}px` : '10px'};
    color: transparent;
    position: relative;
    overflow: hidden;
    &:before {
        content: "";
        position: absolute;
        left: 0%;
        top: 0;
        height: 100%;
        width: 50px;
        background: linear-gradient(to right, #e0e0e0 25%, #d5d5d5 50%, #e0e0e0 100%);
        animation-name: ${gradientKeyframeAnimation};
        animation-duration: 2s;
        animation-iteration-count: infinite;
        filter: blur(5px);
    }
`;